import { Component } from 'react';
import SmartInput from './smart-input';
import SmartSelect from './smart-select';
import SmartCheckbox from './smart-checkbox';
import SmartErrorConsole from './smart-error-console';
import { validateEmailWrapper, validatePasswordWrapper, validateRequiredField } from '../../../services/utils/form';

import './smart-form.css';

class SmartForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: [],
      input_validations: {},
      submitting: false,
    };
  }

  componentDidMount() {
    this.flushData();
    this.prepareInputValidations();
  }

  prepareInputValidationFunction(validationFunction, currentInput) {
    if (currentInput.required) {
      return validationFunction;
    } else {
      return function (value) {
        if (value !== '') {
          return validationFunction(value);
        } else {
          return {
            valid: true,
          };
        }
      };
    }
  }

  prepareInputValidations() {
    const { config } = this.props;
    const inputs = config.inputs;
    const inputValidations = {};

    for (const index in inputs) {
      const currentInput = inputs[index];
      const inputName = currentInput.name;

      if (currentInput.validation) {
        inputValidations[inputName] = currentInput.validation;
      } else if (currentInput.type === 'email') {
        inputValidations[inputName] = this.prepareInputValidationFunction(validateEmailWrapper, currentInput);
      } else if (currentInput.type === 'password') {
        inputValidations[inputName] = this.prepareInputValidationFunction(validatePasswordWrapper, currentInput);
      } else if (currentInput.required) {
        inputValidations[inputName] = this.prepareInputValidationFunction(function (value) {
          return validateRequiredField(currentInput.label, value);
        }, currentInput);
      }
    }
    this.setState({ input_validations: inputValidations });
  }

  flushData() {
    const { config, set } = this.props;

    if (set) {
      return;
    }

    const inputs = config.inputs;
    const data = {};

    for (const index in inputs) {
      const currentInput = inputs[index];

      if (currentInput.type === 'text' || currentInput.type === 'password' || currentInput.type === 'email') {
        data[currentInput.name] = '';
      } else if (currentInput.type === 'select') {
        if (currentInput.multiple) {
          data[currentInput.name] = [];
        } else {
          data[currentInput.name] = '';
        }
      }
    }
    this.setState({ data: data });
  }

  update(inputName, inputValue) {
    const { data } = this.state;
    const newData = { ...data };
    newData[inputName] = inputValue;
    this.setState({ data: newData });
  }

  isFieldActive(fieldConfig) {
    const { data } = this.state;

    if (!fieldConfig.parent_field) {
      //No parent field, active!
      return true;
    }
    //We have a parent field
    const parentFieldValue = data[fieldConfig.parent_field];
    const activeValues = fieldConfig.active_values;

    for (let i = 0; i < activeValues.length; i++) {
      if (activeValues[i] === parseInt(parentFieldValue, 10)) {
        return true;
      }
    }
    return false;
  }

  generateInputs() {
    const { config, clear } = this.props;
    const inputs = config.inputs;
    let shouldClear = false;

    if (clear) {
      shouldClear = true;
    }

    const { set } = this.props;

    let data;
    if (set) {
      set.password = '';
      this.setState({
        data: set,
      });
      data = set;
    } else {
      data = this.state.data;
    }

    return inputs.map((inputConfig) => {
      const value = data[inputConfig.name];

      if (!this.isFieldActive(inputConfig)) {
        return '';
      }

      if (inputConfig.type === 'select') {
        return (
          <SmartSelect config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />
        );
      } else if (inputConfig.type === 'checkbox') {
        return (
          <SmartCheckbox config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />
        );
      } else {
        return <SmartInput config={inputConfig} on_change={this.update.bind(this)} clear={shouldClear} value={value} />;
      }
    });
  }

  validate() {
    const { data, input_validations } = this.state;
    let name;
    const errors = [];
    let isValid = true;

    for (name in input_validations) {
      const currentValue = data[name];
      const validationFunc = input_validations[name];

      const validationResponse = validationFunc(currentValue);

      if (!validationResponse.valid) {
        isValid = false;
        errors.push(validationResponse.message);
      }
    }
    this.setState({ errors: errors });
    return isValid;
  }

  addError(errorMessage) {
    const { errors } = this.state;
    const newErrors = errors;
    newErrors.push(errorMessage);
    this.setState({ errors: newErrors });
  }

  async submit() {
    const { on_submit } = this.props;
    const { data } = this.state;

    const isValid = this.validate();

    if (!isValid) {
      return;
    }

    const submitFunction = on_submit;
    this.setState({ submitting: true });
    await submitFunction(data);
    this.setState({ submitting: false });
  }

  render() {
    const { config, submission_errors } = this.props;
    const { errors, submitting } = this.state;

    const consoleErrors = errors.concat(submission_errors);

    const submitConfig = config.submit;

    let submitText = 'Submit';
    let submitClass = 'smart_form_submit';

    if (submitConfig) {
      if (submitConfig.text) {
        submitText = submitConfig.text;
      }

      if (submitConfig.centered) {
        submitClass += ' centered';
      }
    }

    return (
      <div className="smart_form_container">
        <form className="smart_form">
          <SmartErrorConsole errors={consoleErrors} />
          {this.generateInputs()}
          {!submitting && (
            <div className={submitClass} onClick={this.submit.bind(this)}>
              {submitText}
            </div>
          )}
          {submitting && (
            <div className="smart_form_submit_loader">
              Working... <i className="smart_form_submit_loader_icon fa fa-spin fa-spinner"></i>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default SmartForm;
